export const imageMimeTypes = [
  "image/aces",
  "image/avci",
  "image/avcs",
  "image/bmp",
  "image/cgm",
  "image/dicom-rle",
  "image/emf",
  "image/example",
  "image/fits",
  "image/g3fax",
  "image/heic",
  "image/heic-sequence",
  "image/heif",
  "image/heif-sequence",
  "image/jls",
  "image/jp2",
  "image/jpm",
  "image/jpx",
  "image/naplps",
  "image/png",
  "image/prs.btif",
  "image/prs.pti",
  "image/pwg-raster",
  "image/t38",
  "image/tiff",
  "image/tiff-fx",
  "image/vnd.adobe.photoshop",
  "image/vnd.airzip.accelerator.azv",
  "image/vnd.cns.inf2",
  "image/vnd.dece.graphic",
  "image/vnd.djvu",
  "image/vnd.dwg",
  "image/vnd.dxf",
  "image/vnd.dvb.subtitle",
  "image/vnd.fastbidsheet",
  "image/vnd.fpx",
  "image/vnd.fst",
  "image/vnd.fujixerox.edmics-mmr",
  "image/vnd.fujixerox.edmics-rlc",
  "image/vnd.globalgraphics.pgb",
  "image/vnd.microsoft.icon",
  "image/vnd.mix",
  "image/vnd.ms-modi",
  "image/vnd.mozilla.apng",
  "image/vnd.net-fpx",
  "image/vnd.radiance",
  "image/vnd.sealed.png",
  "image/vnd.sealedmedia.softseal.gif",
  "image/vnd.sealedmedia.softseal.jpg",
  "image/vnd.svf",
  "image/vnd.tencent.tap",
  "image/vnd.valve.source.texture",
  "image/vnd.wap.wbmp",
  "image/vnd.xiff",
  "image/vnd.zbrush.pcx",
  "image/wmf",
  "application/x-7z-compressed",
  "application/vnd.rar",
  "application/zip",
  "application/octet-stream",
  "application/x-zip-compressed",
  "multipart/x-zip"
]
